import kebabCase from 'lodash/kebabCase';

/**
 * Creates a URL-safe slug from heading text.
 * Format: h-{slug}[-{index}]
 *
 * Used by both:
 * - getHeadings.ts (for TOC data extraction)
 * - headingId.ts plugin (for DOM id attributes)
 */
export function headingToSlug(text: string, index = 0): string {
  const slug = kebabCase(text);
  const baseSlug = `h-${slug}`;

  return index === 0 ? baseSlug : `${baseSlug}-${index}`;
}
